module.exports = __webpack_public_path__ + "img/b3-3.4fb2c2f.png";